module.exports = "<my-owner-edit-form my-owner=\"$$owner.data.myOwner\"\n  enable-contacts=\"true\"\n  enable-title=\"true\"\n  enable-back=\"true\"\n  class=\"section\">\n</my-owner-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/owner/templates/edit.html
// module id = 1509
// module chunks = 0